/**
 * © 2025 MyDebugger Contributors – MIT License
 */

// Shared layout class utilities

/**
 * Base styling for tool panels and other card-like containers.
 * This class ensures a consistent look across the ecosystem.
 */
export const TOOL_PANEL_CLASS =
  'card-ambient bg-white/90 dark:bg-gray-800/90 p-6 rounded-2xl shadow-lg';

/** Highlight style for active tab elements */
export const ACTIVE_TAB_CLASS =
  'bg-white dark:bg-gray-800 shadow-sm rounded-full';
